export enum AssetViewMode {
  Add = 'add',
  Counters = 'counters',
  Documentation = 'documentation',
  Edit = 'edit',
  Interventions = 'interventions',
  Nomenclatures = 'nomenclatures',
  View = 'view',
}
